import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

function Terms() {
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 600 }}>
        Terms of Service
      </Typography>
      <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>
        Last Updated: {new Date().toLocaleDateString()}
      </Typography>
      
      <Paper elevation={2} sx={{ p: 4, borderRadius: 2, mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph>
          By accessing or using the Check4DNR service, you agree to be bound by these Terms of Service. 
          If you do not agree to these terms, please do not use our service.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          2. Description of Service
        </Typography>
        <Typography variant="body1" paragraph>
          Check4DNR provides a platform for storing and accessing advance medical directives through facial recognition technology. 
          Our service is intended to be used by individuals wishing to store their advance directives and by emergency medical 
          personnel who need to access these documents in emergency situations.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          3. User Accounts
        </Typography>
        <Typography variant="body1" paragraph>
          To use certain features of our service, you must register for an account. You are responsible for maintaining 
          the confidentiality of your account information and for all activities that occur under your account.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          4. Privacy
        </Typography>
        <Typography variant="body1" paragraph>
          Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and disclose 
          information about you. By using our service, you consent to the collection and use of information as described in our Privacy Policy.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          5. User Content
        </Typography>
        <Typography variant="body1" paragraph>
          You retain all rights to the content you upload to our service. By uploading content, you grant us a license to use, 
          store, and display that content for the purpose of providing our service.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          6. Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph>
          Check4DNR is provided "as is" without warranties of any kind. We are not liable for any damages arising from the use of our service.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          7. Changes to Terms
        </Typography>
        <Typography variant="body1" paragraph>
          We may modify these terms at any time. Your continued use of our service after such changes constitutes your acceptance of the new terms.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          8. Contact Information
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms, please contact us at support@check4dnr.com.
        </Typography>
      </Paper>
    </Container>
  );
}

export default Terms;